import {
  AddBasketItemPayload,
  CategoriesEmployeeOrganisation,
  MutationAddBasketItemArgs,
  MutationCreateStoreOrderArgs,
  MutationRemoveBasketItemArgs,
  MutationUpdateBasketItemArgs,
  PayrollPayBanner,
  PayrollPayBasket,
  PayrollPayCheckoutData,
  PayrollPayDepartment,
  PayrollPayFeaturedCategory,
  PayrollPayProductDetail,
  PayrollPayStoreOrder,
  PayrollPayStoreProducts,
  QueryCheckoutDataArgs,
  QueryDepartmentDataArgs,
  QueryProductDetailArgs,
  QueryStoreBasketDataArgs,
  QueryStoreHomeDataArgs,
  QueryStoreProductsDataArgs,
  RemoveBasketItemPayload,
  UpdateBasketItemPayload
} from "@irati/types"
import {createUseMutation, createUseQuery} from "@irati/utils/services/apollo"
import addBasketItemMutation, {getAddBasketItemMutationKey} from "../apollo/query/AddBasketItem"
import getStoreDepartmentsQuery, {getStoreDepartmentsQueryKey} from "../apollo/query/AllDepartments"
import createStoreOrderMutation, {getCreateStoreOrderMutationKey} from "../apollo/query/CreateOrder"
import getDepartmentCategoriesQuery, {getDepartmentCategoriesQueryKey} from "../apollo/query/DepartmentCategories"
import getFeaturedCategoriesQuery, {getFeaturedCategoriesQueryKey} from "../apollo/query/FeaturedCategories"
import getLandingBannersQuery, {getLandingBannersQueryKey} from "../apollo/query/LandingBanners"
import getProductDetailQuery, {getProductDetailQueryKey} from "../apollo/query/ProductDetail"
import removeBasketItemMutation, {getRemoveBasketItemMutationKey} from "../apollo/query/RemoveBasketItem"
import getBasketDataQuery, {getBasketDataQueryKey} from "../apollo/query/StoreBasketData"
import getCheckoutDataQuery, {getCheckoutDataQueryKey} from "../apollo/query/StoreCheckoutData"
import getStoreProductsQuery, {getStoreProductsQueryKey} from "../apollo/query/StoreProducts"
import updateBasketItemMutation, {getUpdateBasketItemMutationKey} from "../apollo/query/UpdateBasketItem"

export const useStoreBannersQuery = createUseQuery<PayrollPayBanner, QueryStoreHomeDataArgs>(getLandingBannersQuery, {
  key: getLandingBannersQueryKey
})

export const useFeaturedCategoriesQuery = createUseQuery<PayrollPayFeaturedCategory, QueryStoreHomeDataArgs>(getFeaturedCategoriesQuery, {
  key: getFeaturedCategoriesQueryKey
})

export const useStoreDepartmentsQuery = createUseQuery<PayrollPayDepartment, QueryStoreHomeDataArgs>(getStoreDepartmentsQuery, {
  key: getStoreDepartmentsQueryKey
})

export const useDepartmentCategoriesQuery = createUseQuery<CategoriesEmployeeOrganisation, QueryDepartmentDataArgs>(
  getDepartmentCategoriesQuery,
  {
    key: getDepartmentCategoriesQueryKey
  }
)

export const useStoreProductsQuery = createUseQuery<PayrollPayStoreProducts, QueryStoreProductsDataArgs>(getStoreProductsQuery, {
  key: getStoreProductsQueryKey
})

export const useProductDetailQuery = createUseQuery<PayrollPayProductDetail, QueryProductDetailArgs>(getProductDetailQuery, {
  key: getProductDetailQueryKey
})

export const useBasketDataQuery = createUseQuery<PayrollPayBasket, QueryStoreBasketDataArgs>(getBasketDataQuery, {
  key: getBasketDataQueryKey
})

export const useAddBasketItemMutation = createUseMutation<AddBasketItemPayload, MutationAddBasketItemArgs>(addBasketItemMutation, {
  key: getAddBasketItemMutationKey
})

export const useUpdateBasketItemMutation = createUseMutation<UpdateBasketItemPayload, MutationUpdateBasketItemArgs>(
  updateBasketItemMutation,
  {
    key: getUpdateBasketItemMutationKey
  }
)

export const useRemoveBasketItemMutation = createUseMutation<RemoveBasketItemPayload, MutationRemoveBasketItemArgs>(
  removeBasketItemMutation,
  {
    key: getRemoveBasketItemMutationKey
  }
)

export const useCheckoutDataQuery = createUseQuery<PayrollPayCheckoutData, QueryCheckoutDataArgs>(getCheckoutDataQuery, {
  key: getCheckoutDataQueryKey
})

export const useCreateStoreOrderMutation = createUseMutation<PayrollPayStoreOrder, MutationCreateStoreOrderArgs>(
  createStoreOrderMutation,
  {
    key: getCreateStoreOrderMutationKey
  }
)
